import Provider from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import connect from './connect/connect';

export { Provider, connectAdvanced, connect };


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/index.js
// module id = 8
// module chunks = 1